import React, { Suspense } from 'react';
import { Spinner } from "react-bootstrap";

import Belt from '../components/Belt';
import Footer from '../components/Footer';
import AuthService from "../services/auth.service";
import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";
import { Link } from 'react-router-dom'
import { Button, Table } from "react-bootstrap";

const BeltClassNewApp = React.lazy(() => import('../classAppComponents/BeltClassNewApp'));
const TabStudentClassPayment = React.lazy(() => import('../classAppComponents/TabStudentClassPayment'));

class PageShowStudentClassAddPayment extends React.Component {

    state = {
        currentUser: AuthService.getCurrentUser(),
        title: "RezerwujKort.pl - Szkółki tenisowe",
        restStudentData: {
            successful: false,
            status: '',
            message: '',
            data: []
        },
        restClassData: {
            successful: false,
            status: '',
            message: '',
            data: []
        }
    }

    async fechGetStudent(url) {

        var data;

        data = await FetchGetDataWithAuthNEW(url);
        if (data) {
            this.setState({ restStudentData: data });
        }
        console.log("restStudentData " + JSON.stringify(this.state.restStudentData)); //usun
    }

    async fechGetClass(url) {

        var data;

        data = await FetchGetDataWithAuthNEW(url);
        if (data) {
            this.setState({ restClassData: data });
        }
        console.log("restClassData " + JSON.stringify(this.state.restClassData)); //usun
    }

    async componentDidMount() {

        document.title = this.state.title;

        var url = "/class_app/" + this.props.match.params.club + "/admin/student/show/" + this.props.match.params.studentId;
        console.log("url " + JSON.stringify(url)); //usun
        await this.fechGetStudent(url);

        var classUrl = "/class_app/" + this.props.match.params.club + "/class/show/" + this.props.match.params.classId;
        if (this.props.match.params.page != null) {
            classUrl = classUrl + "/" + this.props.match.params.page + "/" + this.state.rowsCount;
            this.setState({ currentPage: this.props.match.params.page });
        }
        await this.fechGetClass(classUrl);

    }

    render() {

        var beltClassApp = <div>
            <Suspense fallback={<div>
                <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
            </div>}>
                <BeltClassNewApp club={this.props.match.params.club} />
            </Suspense>
        </div>

        var tabStudentClassPayment = <div>
            <Suspense fallback={<div>
                <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
            </div>}>
                <TabStudentClassPayment
                    club={this.props.match.params.club}
                    studentId={this.props.match.params.studentId}
                    classId={this.props.match.params.classId}
                    type={"0"} />
            </Suspense>
        </div>

        var tabStudentClassPayment = <div>
            <Suspense fallback={<div>
                <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
            </div>}>
                <TabStudentClassPayment
                    club={this.props.match.params.club}
                    studentId={this.props.match.params.studentId}
                    classId={this.props.match.params.classId}
                    type={"1"} />
            </Suspense>
        </div >

        return (

            <div>
               {beltClassApp}

                <div id="content">
                    <div class="container">

                        

                        <br /><br />
                        <b>Szczegóły płatności uczestnika dla szkółki: {this.state.restClassData.data.name}</b>
                        <br /><br />
                        Imie: {this.state.restStudentData.data.name}<br />
                        Nazwisko: {this.state.restStudentData.data.surname}<br />
                        Email: {this.state.restStudentData.data.email}<br />
                        Kiedy dodany: {this.state.restStudentData.data.createdAt}<br /><br />
                        Łącznie do zapłaty: {this.state.restStudentData.data.createdAt}<br />
                        Suma wpłat: {this.state.restStudentData.data.createdAt}<br />
                        Bilans: {this.state.restStudentData.data.createdAt}<br />
                        <br /><br />
                        Lista płatności do uregulowania:
                        <br /><br />
                        {tabStudentClassPayment}
                        <br />
                        <Link to={"/class_app/" + this.props.match.params.club + "/admin/student/add_payment/" +
                            this.props.match.params.classId + "/" + this.props.match.params.studentId + "/0"}>
                            <Button variant="primary">Dodaj płatność</Button>
                        </Link>
                        <br /><br />
                        Lista wpłat:
                        <br /><br />
                        {tabStudentClassPayment}
                        <br /><br />

                        <Link to={"/class_app/" + this.props.match.params.club + "/admin/student/add_student_payment/" +
                            this.props.match.params.classId + "/" + this.props.match.params.studentId + "/1"}>
                            <Button variant="primary">Dodaj wpłatę klienta</Button>
                        </Link>
                        <br /><br />
                    </div>
                </div>


            </div>
        );
    }
}
export default PageShowStudentClassAddPayment;
